import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Chip from "@material-ui/core/Chip";
import Typography from "@material-ui/core/Typography";
import AddIcon from '@mui/icons-material/Add';



interface ChipsProps {
  status: string;
  onClick?: () => void; // Define the type for the status prop
}

const useStyles = makeStyles(() => ({
  chip: {
    margin: '4px',
    width: 'fit-content',
    display: "flex",
    alignItems: "center",
    "& .MuiChip-deleteIcon": {
      display: "none",

    },
    "&:hover": {
      "& .MuiChip-deleteIcon": {
        display: "block",
        color: 'black'

      }
    }

  },
  icon: {
    color: 'black',
    top: "50%",
    display: "none"
  }
}));


const ChipComponent: React.FC<ChipsProps> = ({ status, onClick }) => {
  const classes = useStyles();
  const [iconDisplayed, setIconDisplayed] = React.useState(false);

  const getChipStyle = (status: string) => {
    switch (status) {
      case "CAPTAIN":
        return { backgroundColor: "#4AF075" };
      case "INJURED":
        return { backgroundColor: "#FF3864" };
      case "LOAN":
        return { backgroundColor: "#F2E94E" };
      case "ON LOAN":
        return { backgroundColor: "#F2E94E" };
      case "LOANEE":
        return { backgroundColor: "#FF7800" };
      case "LOANED IN":
        return { backgroundColor: "#F2E94E" };
      case "LOANED OUT":
        return { backgroundColor: "#F2E94E" };
      default:
        return {};
    }
  };

  const getChipBackgroundColor = (status: string): string => {
    switch (status) {
      case "CAPTAIN":
        return "#4AF075";
      case "INJURED":
        return "#FF3864";
      case "LOAN":
      case "ON LOAN":
        return "#F2E94E";
      case "LOANEE":
        return "#FF7800";
      case "RETIRED":
        return "#D9D9D9";
      case "LOANED IN":
        return "#F2E94E" ;
      case "LOANED OUT":
        return "#FF7800";
      default:
        return "#E0E0E0"; // Default color for other statuses
    }
  };


  const chipStyles = React.useMemo(() => ({
    backgroundColor: getChipBackgroundColor(status),
  }), [status]);

  return (
    <>
      {/* {statusArr.map((status, index) => ( */}

      <Chip
        label={status}
        //style={getChipStyle(status)}
        style={chipStyles}
       // className={`${classes.chip}`}
        deleteIcon={<AddIcon className={classes.icon} />}
        onDelete={onClick}
        onClick={onClick}
        classes={{
          root: classes.chip, // This will override the root class
          deleteIcon: classes.icon // This will override the delete icon class
        }}
      />

      {/* ))} */}
    </>
  );
};

export default ChipComponent;
